
import React from "react";

// Types for our markets
export interface Market {
  country: string;
  currency: string;
  code: string;
  flagComponent: React.ReactNode;
  isDefault?: boolean;
  isActive?: boolean;
}

// Liste des pays et devises disponibles
export const availableMarkets: Market[] = [
  {
    country: "Algeria",
    currency: "DZD",
    code: "dz",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden flex">
        <div className="bg-green-600 w-1/2 h-full"></div>
        <div className="bg-white w-1/2 h-full relative flex items-center justify-center">
          <div className="text-red-600 absolute">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z" fill="currentColor" />
              <path d="M14 10.6L11.4 13.2L10 11.8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
      </div>
    ),
  },
  {
    country: "Bahrain",
    currency: "BHD",
    code: "bh",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden">
        <div className="bg-red-600 w-full h-full flex items-center">
          <div className="border-l-white border-l-[8px] border-l-solid h-full ml-2 flex">
            <div className="bg-white w-2 h-2"></div>
            <div className="bg-white w-2 h-2 mt-1"></div>
            <div className="bg-white w-2 h-2 mt-1"></div>
            <div className="bg-white w-2 h-2 mt-1"></div>
            <div className="bg-white w-2 h-2 mt-1"></div>
          </div>
        </div>
      </div>
    ),
  },
  {
    country: "Egypt",
    currency: "EGP",
    code: "eg",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden flex flex-col">
        <div className="bg-red-600 h-1/3 w-full"></div>
        <div className="bg-white h-1/3 w-full flex justify-center items-center">
          <div className="text-amber-900 text-[8px]">🦅</div>
        </div>
        <div className="bg-black h-1/3 w-full"></div>
      </div>
    ),
  },
  {
    country: "Iraq",
    currency: "IQD",
    code: "iq",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden flex flex-col">
        <div className="bg-red-600 h-1/3 w-full"></div>
        <div className="bg-white h-1/3 w-full flex justify-center items-center">
          <span className="text-green-600 text-[6px] font-bold">الله أكبر</span>
        </div>
        <div className="bg-black h-1/3 w-full"></div>
      </div>
    ),
  },
  {
    country: "Jordan",
    currency: "JOD",
    code: "jo",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden flex flex-col relative">
        <div className="bg-black h-1/3 w-full"></div>
        <div className="bg-white h-1/3 w-full"></div>
        <div className="bg-green-600 h-1/3 w-full"></div>
        <div className="absolute h-full w-0 left-0 border-l-[10px] border-l-red-600 border-y-[10px] border-y-transparent"></div>
      </div>
    ),
  },
  {
    country: "Kuwait",
    currency: "KWD",
    code: "kw",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden flex flex-col relative">
        <div className="bg-green-700 h-1/3 w-full"></div>
        <div className="bg-white h-1/3 w-full"></div>
        <div className="bg-red-600 h-1/3 w-full"></div>
        <div className="absolute h-full w-3 left-0 bg-black"></div>
      </div>
    ),
  },
  {
    country: "Lebanon",
    currency: "LBP",
    code: "lb",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden flex flex-col relative">
        <div className="bg-red-600 h-1/3 w-full"></div>
        <div className="bg-white h-1/3 w-full flex justify-center items-center">
          <div className="text-green-600 text-[8px]">🌲</div>
        </div>
        <div className="bg-red-600 h-1/3 w-full"></div>
      </div>
    ),
  },
  {
    country: "Libya",
    currency: "LYD",
    code: "ly",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden">
        <div className="bg-black w-full h-1/3"></div>
        <div className="bg-red-600 w-full h-1/3"></div>
        <div className="bg-green-700 w-full h-1/3 flex justify-center items-center">
          <div className="text-white text-[6px]">★</div>
        </div>
      </div>
    ),
  },
  {
    country: "Morocco",
    currency: "MAD",
    code: "ma",
    flagComponent: (
      <div className="w-8 h-6 border border-gray-200 dark:border-gray-700 rounded-sm overflow-hidden flex justify-center items-center bg-red-600">
        <div className="text-green-600 text-[10px]">★</div>
      </div>
    ),
  },
];
